import { Component, OnInit, inject } from '@angular/core';
// ECharts optimized imports for tree shaking
import * as echarts from 'echarts/core';
import {
  GaugeChart as EChartsGaugeChart
} from 'echarts/charts';
import {
  TooltipComponent,
  TitleComponent
} from 'echarts/components';
import {
  CanvasRenderer
} from 'echarts/renderers';
import { ThemeService } from '../../service/theme-service';

// Register the required components
echarts.use([
  EChartsGaugeChart,
  TooltipComponent,
  TitleComponent,
  CanvasRenderer
]);


@Component({
  selector: 'app-gauge-chart',
  standalone:false,
  templateUrl: './gauge-chart.html',
  styleUrls: ['./gauge-chart.scss'],
})
export class GaugeChart  implements OnInit {
  private themeService = inject(ThemeService);

  constructor() { }

  ngOnInit() {
    this.initGaugeChart();
  }
  initGaugeChart(): void {
    const chartDom = document.getElementById('gaugeChart')!;
    const theme = this.themeService.isDark() ? 'dark' : undefined;
    const myChart = echarts.init(chartDom, theme);
    const option = {
      backgroundColor: 'transparent',
      title: {
        text: 'Gauge Chart Example',
        left: 'center',
        textStyle: {
          color: this.themeService.isDark() ? '#e2e8f0' : '#333'
        }
      },
      tooltip: {
        formatter: '{a} <br/>{b} : {c}%'
      },
      series: [
        {
          name: 'Pressure',
          type: 'gauge',
          detail: {
            formatter: '{value}%',
            color: this.themeService.isDark() ? '#e2e8f0' : '#333'
          },
          data: [{ value: 50, name: 'SCORE' }]
        }
      ]
    };

    option && myChart.setOption(option);
  }
}
